import { render, staticRenderFns } from "./AddressesList.vue?vue&type=template&id=458e4eed&scoped=true&"
import script from "./AddressesList.vue?vue&type=script&lang=ts&"
export * from "./AddressesList.vue?vue&type=script&lang=ts&"
import style0 from "./AddressesList.vue?vue&type=style&index=0&id=458e4eed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458e4eed",
  null
  
)

export default component.exports